import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setAuthHeader,
  clearAuthHeader,
  axiosInstance,
  setJWTAuthHeader,
  clearJWTAuthHeader,
  axiosNewApiInstance,
} from "../../services/api.js";

// Service registration +
export const registerService = createAsyncThunk(
  "auth/registerService",
  async (serviceData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/workshops/register",
        serviceData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Send verification code to phone number +
export const sendVerificationCode = createAsyncThunk(
  "auth/sendVerificationCode",
  async (phone, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/workshops/phone/send-code",
        phone
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Verify phone number +
export const verifyPhoneNumber = createAsyncThunk(
  "auth/verifyPhoneNumber",
  async ({ phone, code }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/workshops/phone/verify-code",
        { phone, code }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Search for service +
export const searchService = createAsyncThunk(
  "auth/searchService",
  async (searchQuery, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/workshops/catalog/search?q=${searchQuery}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//User login +
export const logIn = createAsyncThunk(
  "auth/login",
  async (userData, thunkAPI) => {
    try {
      const { username, password } = userData;

      const body = new URLSearchParams();
      body.append("username", username);
      body.append("password", password);

      const response = await axiosNewApiInstance.post(
        "/api/v1/auth/login",
        body,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      // const { access_token, refresh_token } = response.data;

      // localStorage.setItem("accessToken", access_token);
      // localStorage.setItem("refreshToken", refresh_token);

      // setJWTAuthHeader(access_token);

      console.log("logInResponseData", response.data);
      return response.data;
    } catch (error) {
      console.log("Login error in Thunk:", error);
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Login with Google +
export const logInWithGoogle = createAsyncThunk(
  "auth/logInWithGoogle",
  async (data, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/auth/google-auth",
        data
      );
      // const { access_token, refresh_token } = response.data;
      // localStorage.setItem("accessToken", access_token);
      // localStorage.setItem("refreshToken", refresh_token);
      // setJWTAuthHeader(access_token);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

export const finalizeLogin = createAsyncThunk(
  "auth/finalizeLogin",
  async ({ accessToken, refreshToken }) => {
    localStorage.setItem("accessToken", accessToken);

    localStorage.setItem("refreshToken", refreshToken);

    setJWTAuthHeader(accessToken);

    return {
      accessToken,
      refreshToken,
    };
  }
);

// User logout +
export const logOut = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    const refreshToken =
      state.auth.refreshToken || localStorage.getItem("refreshToken");

    if (!refreshToken) {
      clearJWTAuthHeader();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      return;
    }

    const response = await axiosNewApiInstance.post(
      "/api/v1/auth/logout",
      { refresh_token: refreshToken } // ✅ правильний body
    );

    clearJWTAuthHeader();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    return response.data;
  } catch (error) {
    // 🔐 навіть якщо бек впав — фронт логаутиться
    clearJWTAuthHeader();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    return thunkAPI.rejectWithValue(error.response?.status || "LOGOUT_ERROR");
  }
});

// Refresh user (hydrate + refresh token if needed) +
export const refreshUser = createAsyncThunk(
  "auth/refresh",
  async (_, thunkAPI) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");

      if (!accessToken || !refreshToken) {
        return thunkAPI.rejectWithValue("NO_TOKENS");
      }

      setJWTAuthHeader(accessToken);

      const response = await axiosNewApiInstance.get("/api/v1/users/me");

      return {
        user: response.data,
        access_token: accessToken,
        refresh_token: refreshToken,
      };
    } catch (error) {
      // clearJWTAuthHeader();
      // localStorage.removeItem("accessToken");
      // localStorage.removeItem("refreshToken");

      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message:
          error.response?.data?.message ||
          error.response?.data?.detail ||
          error.message ||
          "Network error",
      });
    }
  }
);

// Send reset email +
export const sendResetEmail = createAsyncThunk(
  "auth/sendResetEmail",
  async (userEmail, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/auth/password-recovery/${userEmail}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message:
          error.response?.data?.message ||
          error.response?.data?.detail ||
          error.message ||
          "Network error",
      });
    }
  }
);

// Reset Password with email +
export const resetPasswordWithEmail = createAsyncThunk(
  "auth/resetPasswordWithEmail",
  async ({ token, password }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/auth/reset-password",
        { token, new_password: password }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message:
          error.response?.data?.message ||
          error.response?.data?.detail ||
          error.message ||
          "Network error",
      });
    }
  }
);

// ! USER
//Get user data +
export const getUserData = createAsyncThunk(
  "auth/getUserData",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get("/api/v1/users/me");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update user avatar
export const updateUserAvatar = createAsyncThunk(
  "auth/updateAvatar",
  async (newAvatar, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("file", newAvatar);

      const response = await axiosInstance.patch(
        "/auth/update_photo/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update user data +
export const updateUserData = createAsyncThunk(
  "auth/updateUserData",
  async (userDataToUpdate, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/users/me`,
        userDataToUpdate
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Change password +
export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async ({ old_password, new_password }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        "/api/v1/users/me/password",
        { current_password: old_password, new_password }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message:
          error.response?.data?.message ||
          error.response?.data?.detail ||
          error.message ||
          "Network error",
      });
    }
  }
);

// ! CHANGE SERVICE
export const changeSelectedService = createAsyncThunk(
  "auth/changeSelectedService",
  async (serviceId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/auth/switch-workshop?workshop_id=${serviceId}`
      );
      const { access_token, refresh_token } = response.data;
      localStorage.setItem("accessToken", access_token);
      localStorage.setItem("refreshToken", refresh_token);
      setJWTAuthHeader(access_token);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
